export enum DateFormat {
  MM_YYYY = "MM/YYYY",
  DD_MM_YYY = "DD/MM/YYYY",
  DD_MM_YYYY = "DD/MM/YYYY",
  DD_MM_YYYY_HH_MM = "DD/MM/YYYY HH:mm",
  HH_MM = '"HH:mm"',
  YYYY_MM_DD = "YYYY-MM-DD",
}
